import { Routes } from '@angular/router';
import { Login } from './pages/auth/login/login';
import { Registration } from './pages/auth/registration/registration';
import { Auth } from './pages/auth/auth';
import { Main } from './pages/main/main';
import { AppEntryRedirect } from './pages/main/app-entry-redirect';
import { Home } from './pages/main/home/home';
import { CallSession } from './pages/main/call-session/call-session';
import { CalendarJoinToken } from './pages/public/calendar-join-token/calendar-join-token';
import { SsoLogin } from './pages/public/sso-login/sso-login';
import { ForgotPassword } from './pages/auth/forgot-password/forgot-password';
import { PasswordReset } from './pages/auth/password-reset/password-reset';
import { AuthGuard } from './core/guards/auth.guard';
import { nonSuperAdminGuard, superAdminGuard } from './core/guards/role.guards';
import { Profile } from './pages/main/profile/profile';
import { AdminManagement } from './pages/main/admin-management/admin-management';
import { SetPassword } from './pages/auth/set-password/set-password';
import { SuperAdminShell } from './pages/super-admin/super-admin-shell';
import { SuperAdminDashboard } from './pages/super-admin/dashboard/super-admin-dashboard';
import { SuperAdminOrganizations } from './pages/super-admin/organizations/super-admin-organizations';
import { SuperAdminBugReports } from './pages/super-admin/bug-reports/super-admin-bug-reports';

export const routes: Routes = [
  {
    path: 'auth',
    component: Auth,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'login' },
      { path: 'login', component: Login },
      // { path: 'register', component: Registration },
      { path: 'forgot-password', component: ForgotPassword },
      { path: 'reset-password', component:  PasswordReset },
      { path: 'set-password', component:  SetPassword }
    ]
  },
  { path: 'calendar/join-token/:token', component: CalendarJoinToken },
  { path: 'call/:sessionId', component: CallSession },
  { path: 'sso/login', component: SsoLogin },
  { path: '', pathMatch: 'full', canActivate: [AuthGuard], component: AppEntryRedirect },
  {
    path: 'platform',
    canActivate: [AuthGuard, superAdminGuard],
    component: SuperAdminShell,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      { path: 'dashboard', component: SuperAdminDashboard },
      { path: 'organizations', component: SuperAdminOrganizations },
      { path: 'bug-reports', component: SuperAdminBugReports },
    ],
  },
  {
    path: '',
    canActivate: [AuthGuard, nonSuperAdminGuard],
    component: Main,
    children: [
      { path: '' , pathMatch: 'full', redirectTo: '/home' },
      { path: 'settings/profile', component: Profile },
      { path: 'settings/admin', component: AdminManagement },
      { path: 'home', pathMatch: 'full', redirectTo: '/home/chat' },
      { path: 'home/:menu', component: Home }
    ]
  }
];
